import styled from 'styled-components';
import { Typ20, Typ40, Typ50 } from '../Typ';
import { type Tool } from 'account/module/modules/timeline/types';

type OuterWrapperProps = {
  $border?: boolean;
  $state?: Tool['state'];
};

export const OuterWrapper = styled.div<OuterWrapperProps>`
  background: transparent;
  position: relative;
  margin-left: 25px;
  border-left: ${props =>
    props.$border
      ? `4px dotted ${props.$state === 'after' ? '#0099a9' : '#CFD8DC'}`
      : '4px solid transparent'};
  padding-bottom: ${props => (props.$border ? '48px;' : '0')};
  padding-left: 58px;

  @media (max-width: 600px) {
    margin-left: 18px;
    border-left-width: 4px;
    padding-bottom: ${props => (props.$border ? '32px;' : '0')};
    padding-left: 36px;
  }
`;

type BulletWrapperProps = {
  $state?: Tool['state'];
};

export const BulletWrapper = styled.div<BulletWrapperProps>`
  position: absolute;
  top: -12px;
  left: -31px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${props => (props.$state === 'after' ? '#0099A9' : '#fff')};
  box-shadow:
    0 1px 6px rgba(0, 0, 0, 0.12),
    0 1px 4px rgba(0, 0, 0, 0.12);

  @media (max-width: 600px) {
    left: -22px;
    top: 0;
    width: 40px;
    height: 40px;
  }
`;

type BulletNumberProps = {
  $state?: Tool['state'];
};

export const BulletNumber = styled(Typ50)<BulletNumberProps>`
  color: ${props =>
    props.$state === 'before'
      ? '#546E7A'
      : props.$state === 'during'
        ? '#0099a9'
        : '#fff'};
  text-align: center;

  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const Title = styled(Typ50)`
  color: #263238;

  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

export const Text = styled(Typ20)`
  color: #546e7a;
  padding-top: 4px;
  display: block;

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 20px;
    padding-top: 8px;
  }
`;

export const Link = styled(Typ40)`
  color: #007079;
  text-decoration: underline;
  padding-top: 16px;
  display: block;
  cursor: pointer;

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 20px;
    padding-top: 8px;
  }
`;
